// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./promo-image-1.jpg");
var dir = previousRequest.replace("promo-image-1.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "promo-image-1.jpg",
	name: "promo-image-1",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/promo-image-1.jpg
// module id = 80
// module chunks = 4